import { BUSCAR_REPASSE_VENDA_SITE, LIMPAR_REPASSE_VENDA_SITE} from '../../actions/types'

export default function reducerRepasseVenda(state = [], action) {
    switch (action.type) {
        case BUSCAR_REPASSE_VENDA_SITE: {
            return action.payload.data;
        }

        case LIMPAR_REPASSE_VENDA_SITE: {
            return [];
        }

        default: {
            return state
        }
    }
}
